import Axios from 'axios'
import { Saga } from 'redux-saga'
import { all, call, put } from 'redux-saga/effects'

import { mapActionError } from '../utils/helpers'

import { accountReportsSagas } from './account/reports'
import { accountNotificationsSagas } from './account/notifications'
import { accountUserSagas } from './account/user'
import { checkoutSagas } from './checkout'
import { companyDetailSagas } from './companyDetail'
import { configSagas } from './config'
import { domainSagas } from './domains'
import { LogActions } from './logs'
import { notificationSagas } from './notifications'
import { orderSagas } from './order'
import { searchSagas } from './search'
import { productsSagas } from './products'
import { userSagas } from './user'
import { ordersSagas } from './orders'
import { profileManagementSagas } from './account/profile-management'
import { importValidationSagas } from './import/import-validation'
import { importHistorySagas } from './account/imports'
import { importSearchSagas } from './import/import-search'
import { importCheckProductsSagas } from './import/import-check-products'
import { invoicesSagas } from './account/invoices/sagas'

function* allSagas(customSaga?: Saga) {
  yield all([
    searchSagas(),
    productsSagas(),
    configSagas(),
    companyDetailSagas(),
    domainSagas(),
    accountReportsSagas(),
    userSagas(),
    accountUserSagas(),
    orderSagas(),
    checkoutSagas(),
    notificationSagas(),
    accountNotificationsSagas(),
    customSaga ? customSaga() : undefined,
    ordersSagas(),
    profileManagementSagas(),
    importValidationSagas(),
    importHistorySagas(),
    importSearchSagas(),
    importCheckProductsSagas(),
    invoicesSagas()
  ])
}

export function* rootSaga(customSaga?: Saga) {
  while (true) {
    try {
      yield call(allSagas, customSaga)
    } catch (e) {
      if (!Axios.isCancel(e)) {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error('Root saga crashed, restarting...', e)
        }

        yield put(LogActions.addLogItem(mapActionError(e, 'ERROR', location.pathname)))
      }
    }
  }
}
